import styled from 'styled-components';
import ActionButton from './component';

export default styled(ActionButton)`
  background-color: white;
  position: fixed;
  bottom: 0;
  padding: 16px;
  width: 320px;
  height: 64px;
  box-shadow: 4px 0 14px 0 rgba(0, 0, 0, 0.2);

  .button {
    width: 100%;
    height: 100%;
    font-weight: 500;

    &:hover {
      cursor: pointer;
    }

    &-create {
      color: white;
      background-color: var(--primary500);
    }

    &-assign {
      color: var(--primary900);
      background-color: var(--primary100);
      border: 0;
    }
  }
`;
